import { useState, useEffect } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useTranslation } from "react-i18next";
import EnglandFlagSrc from "../../assets/mwa/FLAG_EN.svg";
import NorwayFlagSrc from "../../assets/mwa/FLAG_NO.svg";
import SwedenFlagSrc from "../../assets/mwa/FLAG_SE.svg";
import { ListItemIcon, ListItemText } from '@mui/material';
import { GetUsersIdentity } from '../../services/ApiService';
import { getIdToken, msalResult } from '../../authConfig';
import { useLanguage } from './LanguageContext';

// Style for circular flag images
const circularFlagStyle = {
  width: 20, 
  height: 20, 
  borderRadius: '50%',
  objectFit: 'cover' as const
};

export default function SelectLabels() {
  const [age, setAge] = useState('');

  const { theme } = msalResult;

  const handleChange = (event: SelectChangeEvent) => {
    setAge(event.target.value);
  };
  const { i18n } = useTranslation();
  const { setGlobalLanguage, updateLanguagePreference } = useLanguage(); // Access context

  const changeLanguage = async (lng:any) => {

       // Update UI
       setGlobalLanguage(lng);

       // Update API
       const languageName = lng === "no" ? "Norwegian" : lng === "sv" ? "Swedish" : "English";
       await updateLanguagePreference(languageName);
       
    // i18n.changeLanguage(lng);
    // setLanguage(lng === "no" ? "Norwegian" : lng === "se" ? "Swedish" : "English")
  };

  useEffect(() => {
    const fetchUserIdentityInformation = async () => {
      const tokenAccess = await getIdToken();
      GetUsersIdentity(tokenAccess).then((r: any) => {
        if(r?.data?.preferredLanguage === "sv"){
          setAge("se");
          i18n.changeLanguage("se");
        } else if (r?.data?.preferredLanguage === "no"){
          setAge("no");
          i18n.changeLanguage("se");
        } else if(r?.data?.preferredLanguage === "en-GB"){
          setAge("en");
          i18n.changeLanguage("se");
        } else {
          setAge("en")                                                                                                                                                                                                                                                                                                                                                                                                                                                              
        }
      });
    };
    
    fetchUserIdentityInformation();
  }, [i18n]);

  return (
      <FormControl sx={{ m: 0, minWidth: 90, justifyContent:'center' }}>
        <Select
          value={age}
          onChange={handleChange}
          displayEmpty
          sx={{ boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: 0 }, '.css-1636szt':{color:'#ffffff', minWidth:'0px'}, '.css-1yhq19e':{color:'#fffff', minWidth:'0px'}, '.css-bpeome-MuiSvgIcon-root-MuiSelect-icon':{minWidth:'0px', color:'#ffff'}, '.css-cveggr-MuiListItemIcon-root':{minWidth:'0px', color:'#ffff'}, '.css-qiwgdb.MuiSelect-select':{padding:'5px'},'.css-hfutr2-MuiSvgIcon-root-MuiSelect-icon':{color:'#ffff'}, fontFamily: `${theme?.Style?.font} semi bold`, fontSize:'14px', display:'flex', border: '1px solid #ffff', color:'#ffff',borderRadius:'16px', padding:'1px !important', '.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input':{padding: '5px'} }}
          inputProps={{ 'aria-label': 'Without label' }}
        >
          <MenuItem  value={"no"} onClick={() => changeLanguage("no")} style={{display:'flex'}}>
            <div style={{display:'flex'}}>
              <ListItemIcon sx={{minWidth:'24px'}}>
                <div style={{...circularFlagStyle, overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <img 
                    src={NorwayFlagSrc} 
                    style={{width: '100%', height: '100%'}} 
                    alt="Norway" 
                    loading="lazy"
                  />
                </div>
              </ListItemIcon>
              <ListItemText disableTypography primary="NO" style={{ fontFamily: theme?.Style?.font, fontSize:'14px', margin:'0px'}} />
            </div>
          </MenuItem>
         
          <MenuItem value={"se"}   onClick={() => changeLanguage("sv")} style={{display: 'flex'}}>
            <div style={{display:'flex'}}>
              <ListItemIcon sx={{minWidth:'24px'}}  >
                <div style={{...circularFlagStyle, overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <img 
                    src={SwedenFlagSrc} 
                    style={{width: '100%', height: '100%'}} 
                    alt="Sweden" 
                    loading="lazy" 
                  />
                </div>
              </ListItemIcon>
              <ListItemText disableTypography primary="SE" style={{fontFamily: theme?.Style?.font, fontSize:'14px', margin:'0px'}}/>
            </div>
          </MenuItem>
          <MenuItem  value={"en"} onClick={() => changeLanguage("en")} style={{display: 'flex'}}>
            <div style={{display:'flex'}}>
              <ListItemIcon sx={{minWidth:'24px'}}>
                <div style={{...circularFlagStyle, overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <img 
                    src={EnglandFlagSrc} 
                    style={{width: '100%', height: '100%'}} 
                    alt="English" 
                    loading="lazy"
                  />
                </div>
              </ListItemIcon>
              <ListItemText disableTypography primary="EN" style={{fontFamily: theme?.Style?.font, fontSize:'14px',margin:'0px'}} />
            </div>
          </MenuItem>
        </Select>
        
      </FormControl>
  );
}
